import { createContext, useContext, PropsWithChildren, useState} from "react";

// @ts-ignore
export const BillingEnquirycontext = createContext();

type Props = {};

export function BillEnquiryProvider({ children }: PropsWithChildren<Props>) {

    const [billingEnquiryObj, setBillingEnquiryObj] = useState({});


    return (
        <BillingEnquirycontext.Provider value={{ billingEnquiryObj, setBillingEnquiryObj }}>
            {children}
        </BillingEnquirycontext.Provider>
    );
}

export const useBillingEnquiryContext = () => useContext(BillingEnquirycontext);
